window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      document.querySelectorAll('.cpap__prescription-cards__open-popup').forEach((node) => {
        node.addEventListener('click', (event) => {
          window.cpap.openFlyout(`#${event.currentTarget.dataset.popupId}`);
        });
      });
    },
    { priority: 'user-blocking' }
  );
});
